import React from 'react';
import { Eye, Palette, LayoutGrid, Tag } from 'lucide-react';
import CategorySelector from './CategorySelector';
import QuadrantSelector from './QuadrantSelector';
import { colorOptions } from './noteStyles';
import StickyNotePreview from './StickyNotePreview';

const NoteEditor = ({
  editedFields,
  onFieldUpdate,
  onSubtaskEdit,
  onSubtaskAdd,
  onSubtaskDelete
}) => {
  return (
    <div className="flex gap-6 overflow-x-auto">
      {/* Settings Panel - fixed width */}
      <div className="w-52 flex-shrink-0 ml-1 mb-1">
        <div className="space-y-3">
          <div>
            <label className="flex items-center mb-1.5 text-sm font-medium text-gray-700">
              <LayoutGrid size={18} className="mr-1.5" />
              Quadrant
            </label>
            <QuadrantSelector
              selectedQuadrant={editedFields.quadrant}
              onQuadrantChange={(value) => onFieldUpdate('quadrant', value)}
            />
          </div>


          <div>
            <label className="flex items-center mb-1.5 text-sm font-medium text-gray-700">
              <Tag size={18} className="mr-1.5" />
              Category
            </label>
            <CategorySelector
              selectedCategory={editedFields.category}
              onSelectCategory={(value) => onFieldUpdate('category', value)}
            />
          </div>

          <div>
            <label className="flex items-center mb-1.5 text-sm font-medium text-gray-700">
              <Palette size={18} className="mr-1.5" />
              Note Color
            </label>
            <div className="grid grid-cols-5 gap-1">
              {colorOptions.map((color) => (
                <button
                  key={color.class}
                  className={`w-full h-6 rounded ${color.class} ${editedFields.color === color.class ? 'ring-2 ring-purple-500' : ''
                    }`}
                  onClick={() => onFieldUpdate('color', color.class)}
                  title={color.name}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Preview Panel - fixed width */}
      <div className="w-72 flex-shrink-0">
        <div>
          <label className="flex items-center mb-1.5 text-sm font-medium text-gray-700">
            <Eye size={18} className="mr-1.5" />
            Preview
          </label>
          <StickyNotePreview
            title={editedFields.title}
            category={editedFields.category}
            color={editedFields.color}
            subtasks={editedFields.subtasks}
            onUpdateTitle={(newTitle) => onFieldUpdate('title', newTitle)}
            onEditSubtask={onSubtaskEdit}
            onSubtaskAdd={onSubtaskAdd}
            onSubtaskDelete={onSubtaskDelete}
          />
        </div>
      </div>
    </div>
  );
};

export default NoteEditor;